import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "reactstrap";
import { getAreas, addArea } from "store/actions";
import CreateArea from "./CreateArea";
import AreaTable from "./AreaTable";
import Breadcrumb from "components/Common/Breadcrumb2";

const AreaList = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const areas = useSelector((state) => state.Area.areas);
  const loading = useSelector((state) => state.Area.loading);
  const error = useSelector((state) => state.Area.error);

  const permissions = JSON.parse(localStorage?.getItem("permissions"));

  useEffect(() => {
    if (loading) return;
    dispatch(getAreas());
  }, [dispatch]);

  const handleSubmit = (data) => {
    dispatch(addArea(data));
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      {/* Modal for create/edit */}
      <CreateArea
        visible={isOpen}
        onSubmit={handleSubmit}
        handleClose={handleClose}
      />

      <div className="page-content container-fluid">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mx-3">
          <Breadcrumb
            title="Areas"
            breadcrumbItems={[
              { title: "Dashboard", link: `/dashboard` },
              { title: "Areas", link: "#" },
            ]}
          />
          {permissions
            ?.map((item) => item?.permissionName)
            ?.includes("Add Area") && (
            <Button
              className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center"
              onClick={() => setIsOpen(true)}
            >
              <i className="ti-plus"></i> Add New
            </Button>
          )}
        </div>

        {/* Table */}
        <AreaTable List={areas?.Data} loading={loading} error={error} />
      </div>
    </>
  );
};

export default AreaList;
